<template>
  <div class="modal-wrapper">
    <div class="modal">
      <div class="modal-header">
        <div class="new-input">
          <span class="mck">N</span>
          <input type="text" placeholder="Търсене" v-model="search" />
        </div>
        <span class="mck modal-close" @click="close()">F</span>
      </div>
      <div class="modal-content">
        <table>
          <thead>
            <tr>
              <th>ЧАСТИ</th>
              <th></th>
              <th>БЮДЖЕТ</th>
              <th>НОТИФИКАЦИИ</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(p, i) in iParts"
              :key="`activityModal2-${i}`"
              :title="p.name"
            >
              <td>
                <span class="mck icon">i</span>
                {{ p.name }}
              </td>
              <td class="modal-content-item">
                <span class="mck edit" @click="selectedPart = p" title>c</span>
              </td>
              <td>
                <input
                  :value="formatCurrency(p.budget)"
                  disabled="true"
                />
              </td>
              <td class="right">
                <div class="switch-container">
                  <label class="switch">
                    <input
                      type="checkbox"
                      :checked="partNotifications.indexOf(p.name) > -1"
                      @change="updatePartNotifications(p.name)"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </td>
            </tr>
            <tr v-for="(p, i) in parts" :key="`activityModal-${i}`" :title="p">
              <td>{{ p }}</td>
              <td class="modal-content-item">
                <span class="mck edit" @click="selectedPart = p" title>c</span>
              </td>
              <td>
                <input
                  :value="formatCurrency(totals[p])"
                  disabled="true"
                />
              </td>
              <td class="right">
                <div class="switch-container">
                  <label class="switch">
                    <input
                      type="checkbox"
                      :checked="partNotifications.indexOf(p) > -1"
                      @change="updatePartNotifications(p)"
                    />
                    <span class="slider"></span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <!-- NO RESULTS -->
        <p class="modal-content-no-results" v-if="!parts.length">
          Няма намерени резултати за '
          <strong>{{ this.search }}</strong
          >'
        </p>
      </div>
      <div class="modal-footer">
        <div class="btns">
          <!--  -->
          <button class="btn btn-new2" @click="addNewPart = true">
            <span class="mck2">+</span>
            Нова част
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запази
          </button>
        </div>
      </div>
    </div>
    <transition name="fade">
      <EditPartModal
        v-if="selectedPart !== null || addNewPart"
        :newPart="addNewPart"
        :activities="activities"
        :selected="selectedPart"
        @close="
          selectedPart = null;
          addNewPart = false;
        "
        @save="saveEditedParts"
      />
      <EditPartModal
        v-if="createNewPart"
        :activities="activities"
        :selected="''"
        @close="createNewPart = false"
        @save="addPart"
      />
    </transition>
  </div>
</template>

<script>
import EditPartModal from "./EditPartModal";
import { formatCurrency } from "../../utils/currency";
export default {
  components: {
    EditPartModal,
  },
  props: [
    "incomingMechanizations",
    "incomingRentedMechanizations",
    "incomingMaterials",
    "incomingActivities",
    "incomingManHours",
    "incomingPartNotifications",
    "incomingParts",
    "parts",
  ],
  watch: {
    incomingMechanizations() {
      this.init();
    },
    incomingRentedMechanizations() {
      this.init();
    },
    incomingMaterials() {
      this.init();
    },
    incomingActivities() {
      this.init();
    },
    incomingManHours() {
      this.init();
    },
    incomingPartNotifications() {
      this.init();
    },
    incomingParts() {
      this.init();
    },
  },
  data() {
    return {
      selectedIndex: null,
      selectedPart: null,
      createNewPart: false,
      mechanizations: [],
      rentedMechanizations: [],
      materials: [],
      activities: [],
      manHours: [],
      partNotifications: [],
      iParts: [],
      search: "",
      totals: {},
      notifications: {},
      addNewPart: false,
    };
  },
  // computed: {
  //   getParts() {
  //     const parts = [];

  //     for (let a of this.activities) {
  //       if (parts.indexOf(a.part) === -1) {
  //         parts.push(a.part);
  //       }
  //     }

  //     return parts.sort();
  //   },
  // },
  methods: {
    formatCurrency,
    saveEditedParts(part) {
      if (typeof part === "object") {
        if (this.addNewPart) {
          this.iParts.push(part);
          this.addNewPart = false;
        } else {
          part.prevPart = this.selectedPart.name;
          const i = this.iParts.findIndex((p) => p === this.selectedPart);
          part.updateInReports = true;
          if (i > -1) this.$set(this.iParts, i, part);

          const j = this.partNotifications.indexOf(this.selectedPart.name);
          if (j > -1) this.$set(this.partNotifications, j, part.name);

          this.selectedPart = null;
        }
      } else {
        if (this.selectedPart !== part) {
          for (let m of this.mechanizations) {
            if (m.part === this.selectedPart) {
              m.prevPart = m.part;
              m.part = part;
              m.updateInReports = true;
            }
          }
          for (let m of this.rentedMechanizations) {
            if (m.part === this.selectedPart) {
              m.prevPart = m.part;
              m.part = part;
              m.updateInReports = true;
            }
          }
          for (let m of this.materials) {
            if (m.part === this.selectedPart) {
              m.prevPart = m.part;
              m.part = part;
              m.updateInReports = true;
            }
          }
          for (let a of this.activities) {
            if (a.part === this.selectedPart) {
              a.prevPart = a.part;
              a.part = part;
              a.updateInReports = true;
            }
          }
          for (let mh of this.manHours) {
            if (mh.part === this.selectedPart) {
              mh.part = part;
              mh.updateInReports = true;
            }
          }
          // UPDATE PART IN NOTIFICATIONS ARRAY
          const i = this.partNotifications.indexOf(this.selectedPart);
          if (i > -1) this.$set(this.partNotifications, i, part);
        }
        this.selectedPart = null;
        this.save();
      }
    },
    close() {
      this.$emit("close");
    },
    addPart(p) {
      let newActivity = {
        name: p,
        unit: "мсм",
        price: 0,
        isAdditional: true,
        part: "Автоматична",
      };

      this.parts.push(p);
      this.activities.push(newActivity);
      this.createNewPart = false;
    },
    save() {
      this.$emit("save", {
        mechanizations: this.mechanizations,
        rentedMechanizations: this.rentedMechanizations,
        materials: this.materials,
        activities: this.activities,
        manHours: this.manHours,
        partNotifications: this.partNotifications,
        parts: this.iParts,
      });
    },
    init() {
      this.mechanizations = this.$cloneDeep(this.incomingMechanizations);
      this.rentedMechanizations = this.$cloneDeep(
        this.incomingRentedMechanizations
      );
      this.materials = this.$cloneDeep(this.incomingMaterials);
      this.activities = this.$cloneDeep(this.incomingActivities);
      this.manHours = this.$cloneDeep(this.incomingManHours);
      this.iParts = this.$cloneDeep(this.incomingParts);

      this.partNotifications = this.$cloneDeep(
        this.incomingPartNotifications
      );

      // this.partNotifications = this.partNotifications.filter((pn) => {
      //   return this.getParts.indexOf(pn) > -1;
      // });

      this.calculateTotals();
    },
    handleEvents(e) {
      if (e.code === "Enter") {
        // this.save();
      } else if (e.code === "Escape") {
        this.close();
      }
    },
    calculateTotals() {
      this.totals = {};

      for (let x of [
        "incomingMaterials",
        "incomingMechanizations",
        "incomingRentedMechanizations",
      ]) {
        for (let m of this[x]) {
          if (m.part) {
            if (!this.totals[m.part]) {
              this.totals[m.part] = 0;
            }
            this.totals[m.part] += (+m.price || 0) * (+m.quantity || 0);
          }
        }
      }

      for (let mh of this.incomingManHours) {
        if (!this.totals[mh.part]) {
          this.totals[mh.part] = 0;
        }
        this.totals[mh.part] += (+mh.position.rate || 0) * (+mh.quantity || 0);
      }

      // for (let a of this.incomingActivities) {
      //   if (a.part) {
      //     if (!this.totals[a.part]) {
      //       this.totals[a.part] = 0;
      //     }
      //     this.totals[a.part] += (+a.price || 0) * (+a.quantity || 0);
      //   }
      // }
    },
    updatePartNotifications(p) {
      const i = this.partNotifications.indexOf(p);
      if (i > -1) {
        this.partNotifications.splice(i, 1);
      } else {
        this.partNotifications.push(p);
      }
    },
  },
  mounted() {
    this.init();

    window.addEventListener("keydown", this.handleEvents);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEvents);
  },
};
</script>

<style scoped>
.modal-wrapper {
  justify-content: center;
}
.modal {
  width: 540px;
}
.modal-content-item.with-edit {
  padding-right: 40px;
}
.modal-content-item.with-edit > div {
  align-items: center;
  display: flex;
}
.mck.icon {
  color: #d88e0f;
  font-size: 8px;
  margin-left: -11px;
  margin-right: 1px;
}
.modal-content-item .mck.edit {
  right: 10px;
}
table {
  width: 100%;
}
tr th {
  color: #000;
  font-weight: 700;
  padding: 0 5px 10px;
  text-align: right;
}
tr th:first-child {
  text-align: left;
}
.switch-container {
  justify-content: flex-end;
}
.switch {
  margin: 0;
}
tr td {
  padding: 3px 5px;
}
tr td:first-child {
  width: 100%;
}
table input {
  border-radius: 4px;
  border: 1px solid #cacaca;
  padding: 5px 7px;
  text-align: right;
  width: 120px;
}
.modal-content-item:hover {
  background-color: transparent;
}
.modal-content-item .mck.edit {
  opacity: 1;
  position: relative;
  right: 0;
}
.desktop {
  display: initial;
}
.mobile {
  display: none;
}

/* Responsive */
@media screen and (max-width: 1000px) {
  .modal {
    overflow: unset;
    width: 90%;
  }
  .modal-content-item {
    height: 55px;
    width: 100%;
  }
  .modal-content-check {
    margin-bottom: 5px;
    width: 100%;
  }
}
@media screen and (max-width: 700px) {
  .modal-footer {
    height: 98px;
    flex-direction: column;
  }
  .btn.btn-new {
    margin-bottom: 0.8em;
  }
  .btns-select {
    display: flex;
    justify-content: center;
    margin-top: 1em;
  }
  .btn-select {
    padding: 0 10px;
  }
}
@media screen and (max-width: 600px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: initial;
  }
  .modal-header .new-input {
    width: 60%;
  }
}
@media screen and (max-width: 500px) {
  .btns {
    display: flex;
    flex-direction: column;
  }
  .btn.btn-excel {
    margin-bottom: 0.5em;
  }
}
</style>
